//= include jquery.js
//= include jquery-ui.js
//= include jquery.ui.touch-punch.js
//= include what-input.js
//= include jquery.topzindex.min.js
//= include slick.js
//= include foundation.js
//= include app/app.js
//= include app/components/alert.js
//= include common/template/password.js
//= include common/template/video.js

// Fonction qui détecte les changements de hauteur de l'élement elm
function onElementHeightChange(elm, callback){
	var lastHeight = elm.clientHeight, newHeight;
	(function run(){
		newHeight = elm.clientHeight;
		if( lastHeight != newHeight )
			callback();
		lastHeight = newHeight;

        if (elm.onElementHeightChangeTimer)
          clearTimeout(elm.onElementHeightChangeTimer);

		elm.onElementHeightChangeTimer = setTimeout(run, 200);
	})();
}

(function($) {
	if (App.BrowserDetection.isIe9()) {
        $('[placeholder]').focus(function () {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function () {
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur().parents('form').submit(function () {
            $(this).find('[placeholder]').each(function () {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            });
        });
    }

})(jQuery);

// Duvet.js
function templateRender(htmlTemplate, datas)
{
	var datasKeys = $.map(datas, function(data, key) {
		return key;
	});
	var regexPattern = '\{{'+datasKeys.join('\}}|\{{')+'\}}';
	var regex = new RegExp(regexPattern, 'ig');
	return htmlTemplate.replace(regex, function(matched) {
		return datas[matched.replace('{{', '').replace('}}', '')];
	});
}

/** 
 * Fonction qui gère tous les élements sticky. 
 * Utilisée sur les évenement on document.heightchange, document.resize, document.scroll
*/
function stick(){
	$('[sticky]').each(function(i,e){
		sticky($(e));
	});
}

/*
 * Fonction qui ajoute la class "stuck-top" ou "stuck-bottom" si l'élément est sticky et inversement
 * param [jQueryElement] stickyElement : l'élément à rendre sticky
 * param [string: "top" ou "bottom"] direction : positionnement de l'élément sur l'écran
 */
var hasSticked = false;
function sticky(stickyElement, direction) {

	if(!stickyElement.length) {
		return;
	}

	if(typeof direction == 'undefined'){
		direction = (['bottom','top'].indexOf(stickyElement.attr('sticky-direction')) != -1)?stickyElement.attr('sticky-direction'):'top';
	}

	if(!stickyElement.data('offsetTop')) stickyElement.data('offsetTop',stickyElement.offset().top);
	if(!stickyElement.data('offsetBottom')) stickyElement.data('offsetBottom',( stickyElement.offset().top + stickyElement.height() ) );
	stickyElement.find('.sticky').css('top','').removeClass('stuck-top');
	
	// Element à l'intérieur duquel on stick
	var stickIn = stickyElement.find('[stick-in]');
	var stickyChild = stickyElement.find('.sticky');

	if(!stickyChild.length) return false;
	
	var $compensator = stickyChild.attr('compensate-stick') ? ( $(stickyChild.attr('compensate-stick')) ? $(stickyChild.attr('compensate-stick')) : false ) : false;

	var offsetMargins = {top : 0, bottom : 0};
	// Sticky au top
	if (direction === 'top') {
		
		var isDefaultPosition = $(window).scrollTop() == 0;
		var overStickIn = stickIn.length ? ($(window).scrollTop() > stickIn.offset().top + stickIn.height()) : false;
		if (isDefaultPosition) {
			stickyChild.css('top','auto');
		} else {
			if ($(window).scrollTop() > stickyChild.offset().top)  {

				stickyChild.addClass('stuck-top');
	
				if(!hasSticked){
					$(window).trigger('sticked');
					hasSticked = true;
				}
				
				if($compensator){
					$compensator.css('padding-top', (stickyChild.outerHeight(true))+'px');
					$compensator.css({'padding-top': '0px'});
				}
				
				if(overStickIn){
					var top = $(window).scrollTop() - (stickIn.offset().top + stickIn.height());
					stickyChild.css('top','-'+top+'px');
				}else{
					stickyChild.css('top','0px');
				}
			} else if ($(window).scrollTop() <= stickyChild.offset().top) {

				if (hasSticked) {
					$(window).trigger('unsticked');
					hasSticked = false;
				}
				stickyChild.removeClass('stuck-top');
				$compensator.css({'padding-top': '0px'});
			}
		}

	} else if(direction == 'bottom'){
		var stickCeil = stickyElement.offset().top + stickyChild.height() - offsetMargins.top ;
		if ($(window).scrollTop() + $(window).height() >=  stickCeil) {
			stickyChild.removeClass('stuck-bottom');
		} else {
			stickyChild.addClass('stuck-bottom');
		}
	}
}

$(document).on('scroll resize',function(){ stick(); });

// vérifie si une touche appuyé est imprimable ou non
function printableKeyCode(keycode) {
	var valid =
		(keycode > 47 && keycode < 58) || // number keys
		keycode == 32 || keycode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
		(keycode > 64 && keycode < 91) || // letter keys
		(keycode > 95 && keycode < 112) || // numpad keys
		(keycode > 185 && keycode < 193) || // ;=,-./` (in order)
		(keycode > 218 && keycode < 223);   // [\]' (in order)
	return valid;
};

$(document).on('keydown', '.numeric_field', field_number);
// function field_number(e) {
// 	// Allow: backspace, delete, tab, escape, enter and .
// 	if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 188]) !== -1 ||
// 		// Allow: Ctrl/cmd+A
// 		(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
// 		// Allow: Ctrl/cmd+C
// 		(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
// 		// Allow: Ctrl/cmd+X
// 		(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
// 		// Allow: home, end, left, right
// 		(e.keyCode >= 35 && e.keyCode <= 39)) {
// 		// let it happen, don't do anything
// 		return;
// 	}

// 	// Ensure that it is a number and stop the keypress
// 	var authorizedKeys = '0123456789';
// 	if(authorizedKeys.indexOf(e.key) == -1) {
// 		e.preventDefault();
// 		e.stopPropagation();
// 	}
// }
function field_number(e) 
{
	// Autoriser les nombres
	if (e.key == "0" || e.key == "1" ||e.key == "2" ||e.key == "3" ||e.key == "4" ||e.key == "5" ||e.key == "6" ||e.key == "7" ||e.key == "8" ||e.key == "9" || 
	  // Allow: Ctrl/cmd+A
	  (e.key == "a" && (e.ctrlKey === true || e.metaKey === true)) ||
	  // Allow: Ctrl/cmd+C
	  (e.key == "c" && (e.ctrlKey === true || e.metaKey === true)) ||
	  // Allow: Ctrl/cmd+X
	  (e.key == "x" && (e.ctrlKey === true || e.metaKey === true)) ||
	  // Allow: Ctrl/cmd+V
	  (e.key == "v" && (e.ctrlKey === true || e.metaKey === true)) ||
	  // Allow: home, end, left, right
	  (e.key == "Home" || e.key == "End" || e.key == "ArrowLeft" || e.key == "ArrowRight" ) ||
	  // Autoriser: backspace, delete, tab, escape, enter and .
	  ( e.key == "Backspace"  || e.key == "Enter"  || e.key == "Delete"  || e.key == "Tab"  || e.key == "."  || e.key == "Escape"))      
	  {
		// let it happen, don't do anything
		return;
	  }
	  else {
		// Si ce n'est pas un nombre ou une commande autorisée (ctrl/cmd + touche), on bloque l'entrée.
		e.preventDefault();
	  }
}

$(document).on('keyup', '.numeric_field', function(){
	var newVal = $(this).val().replace(/[,;]/g,'.');
	$(this).val(newVal);
});

/**
 * Fonction de récupération des fichiers de langue
 * @param {type} langEntry
 * @param {type} params
 * @param {type} langFile
 * @returns {__.foundItem|__.langFile|lang|Boolean}
 */
function __(langEntry, params, langFile)
{
	if (arguments.length < 2 && typeof params == "undefined") {
		params = {};
	}
	
	if (arguments.length < 3  && typeof langFile == "undefined") {
		//Common javascript lang file
		var langFile = lang;
	}

	var item = langEntry.split('.');
	
	var foundItem = langFile; 
	for(var i = 0; foundItem[item[i]]; i++) {
		foundItem = foundItem[item[i]];
	}
	
	//Si la length de la chaine coupée est différente de foundItem
	//On a donc rien trouvé
	if (i !== item.length) {
		console.log('[Lang entry] ' + langEntry + ' not found');
		return false;
	}


	if (typeof item !== "undefined" ) {
		var returnedItem = foundItem;
		if (!$.isEmptyObject(params) && typeof returnedItem === "string") {
			for (var key in params) {
				var pattern = new RegExp('\:' + key, 'g');
				returnedItem = returnedItem.replace(pattern, params[key]);
			}
		}
		return returnedItem;
	}
}

function parseOptions($el) {
	var opts = {};
	function parseValue(str) {
		if ('true' === str)
			return true;
		else if ('false' === str)
			return false;
		else if (!isNaN(str * 1))
			return parseFloat(str);
		return str;
	}
	if ($el.attr('data-options')) {
		var thing = $el.attr('data-options').split(';').forEach(function (e, i) {
			var opt = e.split(':').map(function (el) {
				return el.trim();
			});
			if (opt[0])
				opts[opt[0]] = parseValue(opt[1]);
		});
	}
	return opts;
}

function generateUniqueId(prefix)
{
	var c = 1;
    var d = new Date(),
        m = d.getMilliseconds() + "",
        u = ++d + m + (++c === 10000 ? (c = 1) : c);
	var uniqueId = prefix+u;;
    return uniqueId;
}

//affiche les prix de manière générique
function display_price(price, dec){
	price = parseFloat(price);
	price = price.toFixed(dec);
	var str = price.toString().split('.');
	if (str[0].length >= 4) {
		str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1 ");
	}
	if(!str[1] || str[1] == 0){
	    if(dec > 0){
	        var cpt = 0;
	        str[1] = '';
	        while(cpt < dec){
	            str[1] += '0';
	            cpt++;
	        }
	    }
	    else
	        delete str[1];
	}
  else if(str[1].length > dec)
	    str[1] = str[1].substr(0, dec);
	return str.join(',') + ' ' + '&euro;'; 
}

/**
 * Affiche ou cache la page de chargement
 * @param show, if not set, true by default
 */
function loading(show)
{
	if (arguments.length == 0) {
		var show = true;
	}
	var loadingOverlay = $('#loading-overlay');
	if (show) {
		loadingOverlay.css('z-index', $.topZIndex() + 1).removeClass('hide');
	} else {
		loadingOverlay.addClass('hide');
	}
	return false;
}

//Supprime les messages d'erreurs
function hideErrors(element) {
	element.find('.is-invalid-input').removeClass('is-invalid-input');
	element.find('.form-error').removeClass('is-visible');
}

$(document).ready(function() {

	// Init sticky elements
	stick();

	if(('[sticky]').length) onElementHeightChange(document.body, function(){ stick(); });

	$(document).on('change keyup', '.input-container input', function() {
		hideErrors($(this).parents('.input-container'));
	});

	if ($('#errors-reveal').length) {
		$('#errors-reveal').foundation('open');
	}
	
	if (flash_errors.length) {
		var content = '<ul>';
		for(var i in flash_errors) {
			content += '<li>' + flash_errors[i] + '</li>';
		}
		content += '</ul>';
		App.Component.Alert.showPopup(content, 'error', __('error.title'));
	}

	if (flash_warnings.length) {
		var content = '<ul>';
		for(var i in flash_warnings) {
			content += '<li>' + flash_warnings[i] + '</li>';
		}
		content += '</ul>';
		App.Component.Alert.showPopup(content, 'warning', __('warning.title'));
	}
	
	if (flash_success.length) {
		var content = '';
		for(var i in flash_success) {
			content += flash_success[i] + '<br/>';
		}
		App.Component.Alert.showPopup(content, 'success', __('success.title'));
	}

	$('[folder]').click(function(){
		fold_element($(this));
	});

	$('[folder][default-folded]').each(function(i,e){
		fold_element($(e), false);
	});

	$(document).on('mouseenter', '[data-rntooltip]',function(e){
		load_tooltip($(this));
	});

	$(document).on('click', '[data-rntooltip][data-disable-hover]', function(){
		load_tooltip($(this));
	})

	$('.burger-nav').click(function() {
		toggle_nav_menu();
	});

	$(window).on('resize', function(ev) {
		var breakpoint = 768;
		//toggle_nav_menu(ev.target.innerWidth < breakpoint)
	})

	// $(document).on('mouseleave', '[data-rntooltip]', function(e){

	// })

});

function load_tooltip($el)
{
	if (!$el.data('zfPlugin')) {
		var tooltip = new Foundation.Tooltip($el);
		if(!$el.attr('data-disable-hover')) {
			tooltip.show();
		}
	}
}

function fold_element($el, slide){
	if(typeof slide == 'undefined') slide = true;

	var id = $el.attr('folder');
	var $foldable = $('[foldable="'+id+'"]');
	slide ? $foldable.slideToggle() : $foldable.toggle();
	$el.find('svg.turnonfold').toggleClass('turned');
}

var k = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
n = 0;
$(document).keydown(function (e) {
    if (e.keyCode === k[n++]) {
        if (n === k.length) {
            $('.reveal').html('<img src="/assets/img/justbookit.gif" />');
            window.App.Component.Alert.showPopup();

            n = 0;
            return false;
        }
    }
    else {
        n = 0;
    }
});

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function setCookie(cname, cvalue, exdays) {
	if(typeof exdays == 'undefined') exdays = 90;
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function deleteCookie( name, path, domain ) {
	if( getCookie(name) ) {
	  var deleteCookie = name + "=" +
		((path) ? ";path="+path:"")+
		((domain)?";domain="+domain:"") +
		";expires=Thu, 01 Jan 1970 00:00:01 GMT";
		document.cookie = deleteCookie;
	}
}

function debounce(func, wait) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			func.apply(context, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (!timeout) func.apply(context, args);
	};
};

function toggle_nav_menu(state)
{
	var $navigation = $('.navigation');
	if(typeof state != 'undefined') 
	{
		if(state) {
			$navigation.addClass('opened');
			$('body').addClass('is-reveal-open');
		} else {
			$navigation.removeClass('opened');
			$('body').addClass('is-reveal-open');
		}
	} else {
		$navigation.toggleClass('opened');
		$('body').toggleClass('is-reveal-open');
	}
}